/* eslint-disable */
/* eslint-disable no-underscore-dangle */ // Don't bother with dangling underscores in this file

/**
 * Creates a middleware that will talk to [Redux DevTools](https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en)
 * @returns {Middleware} The devtools middleware
 */
const createDevtoolsMiddleware = () => {
  /* istanbul ignore if */
  if (typeof window.__REDUX_DEVTOOLS_EXTENSION__ === `function`) {
    return window.__REDUX_DEVTOOLS_EXTENSION__();
  }
  return (arg) => arg;
};

export default createDevtoolsMiddleware;
